module.exports = __webpack_public_path__ + "static/assets/740d2ffdc270a38f10bee14e66cf2372.png";